module.exports = __webpack_public_path__ + "assets/camp_children_icon.9ccf1c39ba33deab3a314da9ee63f888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp/camp_children_icon.png
// module id = 757
// module chunks = 0